import { defineStore } from 'pinia'

export const useStore = defineStore('coreStore', {
    // arrow function recommended for full type inference
    state: () => {
        return {
            user: null, // Estado do usuário (inicialmente não logado)
            isAuthenticated: false, // Estado de autenticação
            token: null,
            redeMarketingJwt: null, // JWT emitido pelo backend rede_marketing (Spring Boot)
            links: []
        }
    },
    actions: {
        login(token) {
            this.token = token
            this.isAuthenticated = true
            this.links = [
                {
                    link: '/dashboard',
                    icone: 'dashboard',
                    nome: 'Dashboard'
                },
                {
                    link: '/treinadores',
                    icone: 'dashboard',
                    nome: 'Treinadores'
                },
                {
                    link: '/mensagens',
                    icone: 'dashboard',
                    nome: 'Mensagens'
                }
            ];
        },
        logout() {
            // Faz logout limpando o estado
            this.token = null;
            this.redeMarketingJwt = null;
            this.isAuthenticated = false;
            this.links = [];
        },
        setRedeMarketingJwt(jwt) {
            this.redeMarketingJwt = jwt;
        }
    },
    persist: {
        enabled: true, // Ativa a persistência
        strategies: [
            {
                key: 'gestor-store', // O nome da chave no localStorage
                storage: localStorage, // Pode usar sessionStorage se preferir
            },
        ],
    }
})